// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uVVw","title":"styles_title__sVAdR"};